export default __webpack_public_path__ + "static/media/restrictedZone.02991c2d.svg";